import { httpClient } from "ultis/axios";

const getListUser = (params) => {
  return httpClient.get("/id/user", {
    params,
  });
};

const getListUserCount = (params) => {
  return httpClient.get("/id/user/count", {
    params,
  });
};

const getListUserRole = (params) => {
  return httpClient.get("/access-mgt/role-create", {
    params,
  });
};

const blockUser = (userId) => {
  return httpClient.post(`/lock-account`, {
    id: userId,
  });
};

const createUser = (payload) => {
  return httpClient.post(`/id/user`, payload);
};

const editUser = ({ id, ...payload }) => {
  return httpClient.put(`/id/user/${id}`, payload);
};

export const UserApi = {
  getListUser,
  getListUserCount,
  getListUserRole,
  blockUser,
  createUser,
  editUser,
};
